<template>
	<div class="comment-unit">
		<v-divider />
		<v-row class="pa-0 ma-0 mt-2" justify="space-between" align="center">
			<div>
				<i v-if="comment.emotion" :class="`far fa-lg fa-${comment.emotion}`" />
				{{ comment.user.full_name }}
			</div>
			<v-row class="pa-0 ma-0" justify="end" align="center" style="margin-left: auto">
				<v-btn
					v-if="$store.getters['auth/authData'].id == comment.user_id"
					small
					color="red"
					outlined
					@click="deleteBtn = true"
					dense
				>
					削除
				</v-btn>
				<div class="ml-2">
					{{ comment.created_at | dateTimeFormatter }}
				</div>
			</v-row>
		</v-row>
		<p v-text="comment.content" style="word-break: break-all; white-space: pre-wrap"></p>
		<template v-if="comment.files_with_url.length">
			<v-btn
				v-for="file in comment.files_with_url"
				:key="file.id"
				:href="file.url"
				small
				target="_blank"
				color="primary"
				class="text-body-2 mt-2 mr-2 btn-no-transform"
				outlined
			>
				<!-- @click="downloadFile(file.id)" -->
				<v-icon class="mr-1">mdi-download</v-icon>
				{{ file.name }}
			</v-btn>
		</template>
		<!-- <template v-else>添付ファイルなし</template> -->
		<div
			v-if="$store.getters['auth/authData'].id == comment.user_id"
			v-show="deleteBtn"
			class="delete-section"
		>
			<v-row class="ma-0 pa-0 mb-2 warning-white" align="center">
				削除したら元に戻すことはできません。
			</v-row>
			<v-row class="ma-0 pa-0" justify="space-around">
				<v-btn class="mx-1" @click="deleteComment" color="red" outlined>削除</v-btn>
				<v-btn class="mx-1" @click="deleteBtn = false" outlined>キャンセル</v-btn>
			</v-row>
		</div>
	</div>
</template>

<script>
import moment from "moment/min/moment.min.js"
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"

export default {
	props: ["comment"],
	data() {
		return {
			deleteBtn: false,
		}
	},
	filters: {
		dateFormatter(date) {
			if (!date) return ""
			return moment(date).format("YYYY/MM/DD")
		},
		timeFormatter(time) {
			if (!time) return ""
			return moment(time).format("HH:mm")
		},
		dateTimeFormatter(dateTime) {
			if (!dateTime) return ""
			return moment(dateTime).format("YYYY/MM/DD HH:mm")
		},
	},
	methods: {
		deleteComment() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/daily_report_comments/${this.comment.id}`
			axios
				.delete(url, { headers })
				.then((res) => {
					this.$emit("delete-comment", this.comment.id)
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "コメントを削除しました。",
					})
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
}
</script>

<style lang="scss" scoped>
.comment-unit {
	min-height: 80px;
	margin-top: 0.5rem;
	position: relative;
}

.delete-section {
	position: absolute;
	background-color: rgba(0, 0, 0, 0.7);
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	button {
		background-color: white;
	}
	.warning-white {
		margin-bottom: 0.5rem;
		color: white;
		font-weight: bold;
	}
}
</style>